<template>
  <div class="report-detail-low-page">
    <layout-header :isFixedHeader="false"></layout-header>

    <div v-if="isReady">
      <div class="report-wrap" style="margin-top: 8rem;">
        <h1 class="title">
          <button type="button" class="btn-back" @click="$router.go(-1)">
            목록으로
          </button>
          세부내역
          <button type="button" class="btn-report-download" @click="downloadReport">
            보고서 다운
          </button>
        </h1>
        <div style="clear: both;"></div>
        <div class="using-wrap twice">
          <h4 class="sub-title">사용량 내역</h4>
          <table class="table">
            <thead>
            <tr>
              <th colspan="2">고객번호</th>
              <td colspan="2" class="text-center">{{ assetData.customerNumber1 }}</td>
            </tr>
            </thead>
            <tbody>
            <tr>
              <th colspan="2" rowspan="2">계약전력</th>
              <th>기존</th>
              <th>변경</th>
            </tr>
            <tr>
              <td class="text-right p16">{{ assetData.currentPower }} kw</td>
              <td class="text-right p16">{{ assetData.recondPower }} kw</td>
            </tr>
            <tr>
              <th colspan="2">사용량</th>
              <td colspan="2" class="text-center">{{ $Util.formatNumber(assetData.usage) }}</td>
            </tr>
            <tr>
              <th colspan="2">사용기간</th>
              <td colspan="2" class="text-center">
                {{ `${$moment(assetData.startUseDate1).format('YYYY.MM.DD')} ~ ${$moment(assetData.endUseDate1).format('YYYY.MM.DD')}` }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <div class="using-wrap">
          <h4 class="sub-title">절감 세부 내역</h4>
          <div class="table-wrap">
            <table class="table">
              <thead>
              <tr>
                <th class="detail-title">구분</th>
                <th class="detail-title">컨설팅 전</th>
                <th class="detail-title">컨설팅 후</th>
              </tr>
              </thead>
              <tbody>
              <tr class="highlight">
                <th class="detail-title">기본요금</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.beforeBasic) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterBasic1) }}</td>
              </tr>
              <tr class="highlight-sub">
                <th class="detail-title">전력량 요금</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterTotalLoad1) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterTotalLoad1) }}</td>
              </tr>
              <tr>
                <th class="detail-title">기후환경요금</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterClimate1) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterClimate1) }}</td>
              </tr>
              <tr>
                <th class="detail-title">연료비조정액</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterFuelAdjust1) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterFuelAdjust1) }}</td>
              </tr>
              <tr>
                <th class="detail-title">모바일 할인</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.mobileDiscount) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.mobileDiscount) }}</td>
              </tr>
              <tr>
                <th class="detail-title">전력기금</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterElectricFund1) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterElectricFund1) }}</td>
              </tr>
              <tr>
                <th class="detail-title">부가가치세</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterVat1) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterVat1) }}</td>
              </tr>
              <tr>
                <th class="detail-title">TV수신료</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterTvLicense1) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterTvLicense1) }}</td>
              </tr>
              <tr>
                <th class="detail-title">정산요금</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterAdjustPrice1) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterAdjustPrice1) }}</td>
              </tr>
              <tr>
                <th class="detail-title">연체료</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.lateFee) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.lateFee) }}</td>
              </tr>
              <tr>
                <th class="detail-title">가산금</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.addFee) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.addFee) }}</td>
              </tr>
              <tr>
                <th class="detail-title">원단위 절사</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterCutWon1) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterCutWon1) }}</td>
              </tr>
              <tr>
                <th class="detail-title">당월요금계</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterMonthBill1 + assetData.savePrice) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterMonthBill1) }}</td>
              </tr>
              <tr>
                <th class="detail-title">당월 청구요금</th>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterTotalBill1 + assetData.savePrice) }}</td>
                <td class="text-right number">{{ $Util.formatNumber(assetData.afterTotalBill1) }}</td>
              </tr>
              <tr>
                <th colspan="2" class="detail-title">절감율</th>
                <td class="text-right number" colspan="2">{{ assetData.savePriceRate }}%</td>
              </tr>
              <tr>
                <th colspan="2" class="detail-title">절감액</th>
                <td class="text-right number" colspan="2">{{ $Util.formatNumber(assetData.savePrice) }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="using-wrap">
          <h4 class="sub-title">세부내역 차트</h4>
          <div class="table-wrap" style="border: #136599 solid 2px;">
            <report-bar-chart-low
              v-if="isReady"
              v-bind:assetData="assetData"
              v-bind:assetList="assetList"/>
          </div>
        </div>

      </div>
    </div>
    <layout-footer></layout-footer>
  </div>
</template>
<script type="text/javascript">
import ReportBarChartLow from '@/components/chart/reportBarChartLow'

export default {
  components: {
    ReportBarChartLow
  },
  data: function () {
    return {
      isReady: false,
      assetNo: this.$route.query.assetNo,
      assetData: {},
      assetList: [],
    }
  },
  computed: {
    resultFee: function () {
      return Math.floor(this.assetData.savePrice / 2)
    },
    resultVat: function () {
      return Math.round(this.resultFee * 0.1)
    }
  },
  created: function () {
    this.getAssetData()
    this.getAssetList()
  },
  methods: {
    downloadReport: function () {
      setTimeout(() => {
        const a = document.createElement('a')
        a.href = this.$ConstCode.CODE_ENV_LIST.REPORT_PATH_URL + this.assetData.totalReportPath
        a.download = 'download'
        a.target = '_blank'
        a.click()
      }, 1)
    },
    getAssetList: async function () {
      const params = {
        userNo: this.$store.getters['account/getUserData'].userNo,
        page: 1,
        limit: 36
      }
      const res = await this.$AssetSvc.getAssetReportData(params)
      const code = res.code
      const message = res.message
      const entity = res.entity

      console.log('code: %d\nmessage: %s\nentity: %o\nstringify: \n%s', code, message, entity, JSON.stringify(entity))

      if (code === 1) {
        this.assetList = entity.assetList
        this.isReady = true
      }
    },
    getAssetData: async function () {
      const res = await this.$AssetSvc.getAssetData({assetNo: this.assetNo})
      const code = res.code
      const message = res.message
      const entity = res.entity

      console.log('code: %d\nmessage: %s\nentity: %o\nstringify: \n%s', code, message, entity, JSON.stringify(entity))

      if (code === 1) {
        this.assetData = entity

        this.isReady = true
      }
    }
  }
}
</script>
